import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewStats from '../../../components/dashboard/overview';
import QuickActions from '../../../components/dashboard/quick-actions';
import BeneficiaryTable from '../../../components/dashboard/beneficiary/tables/beneficiary-table';
import AddBeneficiaryModal from '../../../components/dashboard/beneficiary/modals/add-beneficiary-modal';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onNewPayoutRequest = () => {
    navigate('/dashboard/new-payout');
  };

  return (
    <div>
      <div className="flex flex-col gap-8">
        <OverviewStats />
        <QuickActions
          onAddNewBeneficiary={toggleModal}
          onNewPayoutRequest={onNewPayoutRequest}
        />
        <BeneficiaryTable onAddNewBeneficiary={toggleModal} />
        <AddBeneficiaryModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
        />
      </div>
    </div>
  );
};
export default Dashboard;
